<template>
  <CRow>
    <CCol
      md="12"
      v-for="(challenge, index) in challenges"
      :key="index"
      class="challenge-item"
    >
      <router-link :to="{name: 'Concursos-Vista', params: { challenge_id: challenge.id }}" class="challenge-link">
        <CCard class="challenge-card mx-auto">
          <CCardHeader>
            {{challenge.name}}
            <div class="card-header-actions">
              <span>...</span>
            </div>
            <br v-if="challenge.provider_id > 0" />
            {{challenge.provider_id > 0 ? "" + challenge.provider_name : ''}}
          </CCardHeader>
          <CCardBody>
            <img v-if="!challenge.image_filename" src="no-image.jpg" class="w-100">
            <img v-if="challenge.image_filename" :src="challenge.image_filename" class="w-100">
          </CCardBody>
          <CCardFooter>
            <div class="challenge-available float-right" v-if="challenge.enabled && challenge.quantity > 0">Premios Disponibles: {{challenge.left}}</div>
            <div class="challenge-unavailable float-right" v-if="!challenge.enabled">NO DISPONIBLE</div>
            <p class="challenge-description">{{challenge.description}}</p>
          </CCardFooter>
        </CCard>
      </router-link>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'ChallengesList',
  props: {
    challenges: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.challenge-item {
  font-size: 12px;
  margin-bottom: 25px;
}

.challenge-card {
  max-width: 400px;
}

.challenge-link {
  text-decoration: none;
  color: black;
}

.challenge-link:hover {
  text-decoration: none;
  color: black;
}

.challenge-available {
  font-size: 11px;
}

.challenge-unavailable {
  font-size: 10px;
  color: red;
}

.challenge-description {
  text-align: justify;
  font-size: 12px;
  padding-right: 10px;
  margin-right: 10px;
  width: 250px;
}
</style>